export const recordClick = (name, templateName = '活动') => {
  try {
    MtaH5.clickStat('button', { 'name': name })
  }
  catch (err) {
    console.log(err)
  }
  try {
    sensors.track("rent_activity", {
      "platform_type": 'H5',
      "page_type": templateName,
      "$is_login_id": true,
      "button_type": name
    });
  }
  catch (err) {
    console.log(err)
  }
}